<template>
    <div class="w-full flex flex-row mb-3 xl:mb-5 align-items-center">
        <div class="block relative bg-green-200 border-circle mr-2 xl:mr-2 height-3 width-3 p-3 xl:p-4">
            <span class="absolute text-xl text-0 left-0 font-medium top-0 ml-2 mt-2 xl:ml-3 xl:mt-3">2</span>
        </div>
        <span class="flex flex-1 text-700 font-medium xl:text-xl">
            {{ content[lang_].title }}
        </span>
    </div>
    <div class="w-full flex flex-column xl:flex-row relative">
        <div v-if="image || url" class="w-full flex flex-column max-w-30rem relative surface-0 border-round-xl xl:border-round-2xl p-3 xl:p-4 mb-1 xl:mb-5">
            <div v-if="image" class="w-full text-center justify-content-center align-items-center">
                <div v-if="image_type=='image'" v-html="image" class="border-round-xl m-0 surface-0 inline-block" style="max-width: min(100%);"></div>
                <div v-if="image_type=='base64'" class="p-3 border-round-xl m-0 surface-0 inline-block" style="max-width: min( 100%);">
                    <img :src="image" alt="QR" style="max-width: 100%;"/>
                </div>
            </div>
            <Button v-if="url" icon="pi pi-external-link" iconPos="right" :label="content[lang_].button" @click="pay_tinkoff()"
                class="w-full border-round-xl"/>
        </div>
        <div v-if="image_type=='image'" class="w-full flex flex-column max-w-30rem relative py-1 xl:py-4 xl:px-8">
            <InlineMessage severity="info" class="border-round-xl line-height-2 text-xs xl:text-md">
                {{ content[lang_].message }}
            </InlineMessage>
        </div>
    </div>
</template>

<script>
import Helper from '@/assets/js/Helper'
import Event from '@/assets/js/Event'
export default {
    props: ['image', 'image_type', 'url'],
	data(){
		return{
			content: {
				en: {
					title: "Pay transfer by SBP",
                    message: "Scan the QR code with your phone camera or through the bank application and proceed to payment.",
                    button: "Pay by SBP",
				} ,
				ru: {
					title: "Оплатите перевод по СБП",
                    message: "Сканируйте QR камерой телефона или через приложение банка и перейдите к оплате.",
                    button: "Оплатить по СБП",
				},
			}, 
		}
	},
	computed: {
		lang_() {
			return (this.$i18n.locale) ? this.$i18n.locale : 'ru'
		},
	},
	methods: {
        copy(text){
            this.helper.copy_clipboard(text)
        },
        pay_tinkoff(){
            this.event.send('transferPaymentBtn')
            window.open(
                this.url,
                '_blank'
            );
        },
	},
	beforeCreate() {
        this.helper = new Helper()   
        this.event = new Event() 
	}
}
</script>